const literals = require('./literal-types').LITERAL_TYPES
const m = require('moment-timezone')

const escape = (str = '') => str.replace(/([^\\])'/g, '$1\\\'')

const typeConvert = (value, operator, type) => {
  if (operator === 'IN') {
    if (value) {
      const val = typeof value === 'object' && value.filter ? value.filter(f => f) : value
      if (typeof val === 'string') {
        return '(' + `'${val.split(';').map(v => v.trim()).join('\',\'')}'` + ')'
      }
      if (Array.isArray(val)) {
        return '(' + val.map(part => `'${escape(part)}'`).join(',') + ')'
      }
    } else return '()'
  }

  if(value === null) return 'NULL'
  if(type === 'BOOLEAN') return !!value
  if(value && typeof value === 'string' && literals.filter(v => value.startsWith(v)).length) return value
  if(['CURRENCY', 'NUMBER', 'DOUBLE', 'INTEGER'].includes(type)) return value
  if(['DATETIME'].includes(type) && typeof value === 'number') return m.tz(value, m.tz.guess()).format()
  if(['DATE'].includes(type) && typeof value === 'number') return m.tz(value, m.tz.guess()).format('YYYY-MM-DD')
  if(typeof value === 'string') return '\'' + escape(value) + '\''

  if(value === undefined) return type && DEFAULT_TYPES[type]
  return value
}

const buildWhereClause = (where, datasourceType) =>
  where && where.whereClauseOrder && where.whereClauseOrder.split(/(\d+)/).map( t => {
    let i = parseInt(t) - 1
    if(parseInt(t) !== NaN && where.rules.length >= i && i >= 0) {
      let r = where.rules[i]
      if(!r || !r.leftField || !r.leftField.fieldPath || !r.leftField.fieldPath.length) return null

      let { fieldPath, type } = r.leftField
      let { rightValue: val, operator: op } = r

      
      //sql-parser doesn't understand neither CONTAINS. Replace with IN/LIKE
      if (op === 'CONTAINS') {
        if(['MULTIPICKLIST', 'MULTIREFERENCE', 'POLYMULTIREFERENCE'].includes(type)) {
          op = 'IN'
        } else {
          val = `%${val || ''}%`
          op = 'LIKE'
        }
      }

      /*
      * dynamic SOQL crashes on empty IN values (... IN () ).
      * Replace the whole expression with 'ID = null' which is logically equivalent
      */
      if (datasourceType === 'Salesforce' && op === 'IN' && (!val || !val.length)) {
        return 'ID = NULL'
      }
      
      //empty (false/undefined but not null) bools should pick undefined and false values
      if (type === 'BOOLEAN' && ['=', '!='].includes(op) && !val && val !== null) {
        return ['(', fieldPath, op, false, op === '=' ? 'OR' : 'AND', fieldPath, op, 'NULL', ')'].join(' ');

      //empty (false/undefined but not null) strings should pick undefined and empty values
      } else if (STRINGY_TYPES.includes(type) && ['=', '!='].includes(op) && !val && val !== null) {
        return ['(', fieldPath, op, typeConvert(val, op, type), op === '=' ? 'OR' : 'AND', fieldPath, op, 'NULL', ')'].join(' ');

      } else return [fieldPath, op, typeConvert(val, op, type)].join(' ');
    }
    return t
  }).filter(t => t).join('')

const soqlize = ({fields, sobject, where, groupBy, orderBy, having, limit = 1000, addToRecent = false, additionalText, datasourceType}) => {
  fields = fields && fields.filter(f => f).map(({ fieldPath, aggregateFunctionName, aggregateAlias }) => {
    let fname = ''
    if(aggregateFunctionName) {
      fname = aggregateFunctionName + '(' + fieldPath + ')'
    } else {
      fname = fieldPath
    }
    return fname + (aggregateAlias && aggregateAlias.length ? ' AS ' + aggregateAlias : '')
  }).filter(f => f).join(', ') || '*'

  let whereClause = buildWhereClause(where, datasourceType)

  let group = groupBy?.length > 0 && 'GROUP BY ' + groupBy.filter(g => g).map(g => g.fieldPath || g).join(', ')
  let order = orderBy?.length > 0 && 'ORDER BY ' + orderBy.filter(g => g?.field).map(g => `${g.field.fieldPath} ${g.direction || ''}` ).join(', ')
  
  let havingClause = group && buildWhereClause(having, datasourceType)

  let soql = ['SELECT', fields, 'FROM ' + sobject]

  if(whereClause?.length) soql = soql.concat('WHERE', whereClause)
  if(group?.length) soql = soql.concat(group)
  if(havingClause?.length) soql = soql.concat('HAVING', havingClause)
  if(order?.length) soql = soql.concat(order)
  if(additionalText) soql = soql.concat(' ' + additionalText + ' ')
  if(limit) soql = soql.concat('LIMIT', limit)
  if(addToRecent) soql = soql.concat('FOR VIEW')

  return soql.filter(t => t).join(' ')
}

const STRINGY_TYPES = [ 'TEXTAREA', 'EMAIL', 'PHONE', 'STRING', 'URL', 'PHONE', 'ID' ]

const DEFAULT_TYPES = {
  'STRING': '\'\'',
  'EMAIL': '\'\'',
  'URL': '\'\'',
  'PHONE': '\'\'',
  'INTEGER': 0,
  'CURRENCY': 0,
  'DOUBLE': 0,
  'PERCENT': 0,
  'TEXTAREA': '\'\'',
  'BOOLEAN': false,
  'COMBOBOX': '\'\'',
  'PICKLIST': '\'\'',
  'DATE': 'NULL',
  'TIME': 'NULL',
  'DATETIME': 'NULL',
  'MULTIPICKLIST': '\'\'',
  'ID': 'NULL',
  'REFERENCE': 'NULL'
}
module.exports = soqlize
